import { Form } from '@rjsf/antd'
import { IChangeEvent } from '@rjsf/core'
import { RJSFSchema } from '@rjsf/utils'
import { isEmptySchema } from 'Utils/schema.utils'
import { EmptyTemplate } from './templates/EmptyTemplate'
import { TextAreaWidget } from './widgets/TextAreaWidget'
import { JSONObject } from 'Types/Common.types'
import customizeValidator from '@rjsf/validator-ajv8/lib/customizeValidator'
import { ErrorSchema } from '@rjsf/utils'
import { ArrayFieldTemplate } from './templates/ArrayFieldTemplate'
import './JSONSchemaForm.less'

type JSONSchemaFormPropsType = {
    schema?: RJSFSchema
    value: JSONObject
    onChange: (value: JSONObject) => void
    readOnly: boolean
    extraErrors?: ErrorSchema
}

const fallbackSchema: RJSFSchema = {
    type: 'object',
    properties: {
        content: {
            type: 'string',
            format: 'textarea',
            title: 'JSON input',
        },
    },
}

const ajvValidator = customizeValidator()

export const JSONSchemaForm = (props: JSONSchemaFormPropsType) => {
    const schema = isEmptySchema(props.schema) ? fallbackSchema : props.schema

    return (
        <div className="json-schema-form">
            <Form
                schema={schema as RJSFSchema}
                formData={props.value}
                validator={ajvValidator}
                onSubmit={() => {}}
                onChange={(event: IChangeEvent) => {
                    props.onChange(event.formData)
                }}
                extraErrors={props.extraErrors}
                templates={{
                    ErrorListTemplate: EmptyTemplate,
                    ButtonTemplates: {
                        SubmitButton: EmptyTemplate,
                    },
                    ArrayFieldTemplate: ArrayFieldTemplate,
                }}
                widgets={{
                    textarea: TextAreaWidget,
                }}
                disabled={props.readOnly}
            />
        </div>
    )
}
